import React, { useEffect, useState } from "react";
import api from "APP_ROOT/api";
import { get } from "lodash";
import T from "prop-types";
import { toSentence } from "LIB/formatters/text";
import Warning from "../../../shared/components/Warning/Warning";

export default function RestrictedEntityWarning({
  allContacts = false,
  company,
  contactId,
  name,
  requireApproval
}) {
  if ((!company && !name) || (company && !company.name)) return null;

  const [restrictedEntities, setRestrictedEntities] = useState(null);

  useEffect(
    () => {
      const params = { all_contacts: allContacts };
      if (company) {
        params.company_id = company.id;
      } else if (name) {
        params.name = name;
      }

      if (contactId) {
        params.contact_id = contactId;
      }

      api.restrictedEntities.search(params).then(resp => {
        if (Number(get(resp, "data.total", 0)) > 0) {
          setRestrictedEntities(resp.data.results);
        } else {
          setRestrictedEntities(null);
        }
      });
    },
    [company, contactId, name]
  );

  if (!restrictedEntities) return null;

  return (
    <Warning>
      Warning: Similar entity name in US Gov&apos;t Screening List:{" "}
      {toSentence(restrictedEntities.map(f => f.name))}.{" "}
      {requireApproval && "Pre-Approval Required."}
    </Warning>
  );
}

RestrictedEntityWarning.propTypes = {
  company: T.shape({
    id: T.string
  }),
  name: T.string
};



// WEBPACK FOOTER //
// ./app/modules/companies/shared/components/RestrictedEntityWarning.jsx